import { render, staticRenderFns } from "./PreparationIssues.vue?vue&type=template&id=1a5645be&scoped=true&"
import script from "./PreparationIssues.vue?vue&type=script&lang=js&"
export * from "./PreparationIssues.vue?vue&type=script&lang=js&"
import style0 from "./PreparationIssues.vue?vue&type=style&index=0&id=1a5645be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5645be",
  null
  
)

export default component.exports